import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, ArrowUpRight } from "lucide-react";
import { useLanguage } from "../../context/LanguageContext";
import { translations } from "../../i18n/translations";
import { SERVICES } from "../../data/mock";
import { getIcon } from "../../lib/icons";
import SectionHeading from "../SectionHeading";
import Reveal from "../Reveal";

const ServicesOverview = () => {
  const { lang } = useLanguage();
  const t = translations[lang].servicesOverview;

  return (
    <section className="relative bg-navy-950 py-20 lg:py-28 overflow-hidden">
      <div className="absolute inset-0 dot-pattern opacity-40" />
      <div className="relative max-w-7xl mx-auto px-5 lg:px-8">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6">
          <SectionHeading tag={t.tag} title={t.title} desc={t.desc} light />
          <Link
            to="/hizmetlerimiz"
            className="inline-flex items-center gap-2 text-amber-400 font-semibold hover:gap-3 transition-all shrink-0"
          >
            {t.viewAll}
            <ArrowRight className="w-4 h-4" />
          </Link>
        </div>

        <div className="mt-14 grid sm:grid-cols-2 gap-6">
          {SERVICES.map((s, i) => {
            const Icon = getIcon(s.icon);
            return (
              <Reveal key={s.id} delay={i * 100}>
                <Link
                  to={`/hizmetlerimiz/${s.slug}`}
                  className="group relative block h-full rounded-2xl border border-white/10 bg-white/[0.03] p-8 hover:bg-white/[0.06] hover:border-amber-500/40 transition-all duration-300"
                >
                  <div className="flex items-start justify-between">
                    <div className="w-14 h-14 rounded-xl bg-amber-500/15 border border-amber-500/20 flex items-center justify-center">
                      <Icon className="w-7 h-7 text-amber-400" />
                    </div>
                    <ArrowUpRight className="w-5 h-5 text-slate-500 group-hover:text-amber-400 group-hover:-translate-y-0.5 group-hover:translate-x-0.5 transition-all" />
                  </div>
                  <div className="mt-6">
                    <span className="text-xs font-semibold uppercase tracking-wider text-amber-500">
                      {s.number} — {s.tag[lang]}
                    </span>
                    <h3 className="mt-2 font-display font-bold text-xl text-white group-hover:text-amber-400 transition-colors">
                      {s.title[lang]}
                    </h3>
                    <p className="mt-3 text-slate-400 leading-relaxed text-[15px]">
                      {s.short[lang]}
                    </p>
                  </div>
                  <div className="mt-6 flex flex-wrap gap-2">
                    {s.features[lang].slice(0, 3).map((f) => (
                      <span
                        key={f}
                        className="text-xs text-slate-300 bg-white/5 border border-white/10 rounded-full px-3 py-1"
                      >
                        {f}
                      </span>
                    ))}
                  </div>
                </Link>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ServicesOverview;
